import { ResourceType } from "@common/types/auditLog";
import { APIProcessName } from "../process-names";
import { HistoryField, HistoryGroupBy } from "./history-fields";
import type { HistorySourceTypeConfig } from "./history-source-config";
import type { PlatformHistoryTwinsBySourceType } from "../history-platform-twins";
import { toPlatformTwinSources } from "../history-platform-twins";

const COUNTERPARTY_AUDIT_FIELDS = [
    HistoryField.NAME,
    HistoryField.EMAIL,
    HistoryField.PHONE_NUMBER,
    HistoryField.WEBSITE,
    HistoryField.STREET,
    HistoryField.STREET2,
    HistoryField.CITY,
    HistoryField.POSTAL_CODE,
    HistoryField.STATE,
    HistoryField.COUNTRY,
    HistoryField.DIRECTION_OVERRIDE,
    HistoryField.WORKSPACE_ID,
    HistoryField.UPDATED_BY_USER_ID,
    HistoryField.CREATED_FROM_GLOBAL_COUNTERPARTY_ID,
    HistoryField.SHOULD_BE_NORMALIZED,
    HistoryField.WAS_CHECKED_AGAINST_COUNTERPARTY_IDS,
    HistoryField.COUNTERPARTY_ENGINE_VERSION,
    HistoryField.TIN_TYPE,
];

const COUNTERPARTY_DETAIL_PLATFORM_TWINS: PlatformHistoryTwinsBySourceType = {
    [APIProcessName.COUNTERPARTY_CONTACT_CREATE]: null,
    [APIProcessName.COUNTERPARTY_CONTACT_UPDATE]: null,
    [APIProcessName.COUNTERPARTY_CONTACT_DELETE]: null,
    [APIProcessName.COUNTERPARTY_CONTACT_SET_PRIMARY]: null,
    [APIProcessName.COUNTERPARTY_ADDRESS_CREATE]: null,
    [APIProcessName.COUNTERPARTY_ADDRESS_UPDATE]: null,
    [APIProcessName.COUNTERPARTY_ADDRESS_DELETE]: null,
    [APIProcessName.COUNTERPARTY_ADDRESS_SET_PRIMARY]: null,
};

export const counterpartySources: HistorySourceTypeConfig[] = [
    {
        sourceType: APIProcessName.COUNTERPARTY_CREATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.COUNTERPARTY,
                fields: COUNTERPARTY_AUDIT_FIELDS,
                resolveEntity: true,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.COUNTERPARTY_UPDATE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.COUNTERPARTY,
                fields: COUNTERPARTY_AUDIT_FIELDS,
                resolveEntity: true,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.COPY_GLOBAL_COUNTERPARTY,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.COUNTERPARTY,
                fields: COUNTERPARTY_AUDIT_FIELDS,
                resolveEntity: true,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.DELETE_COUNTERPARTY,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.COUNTERPARTY,
                fields: COUNTERPARTY_AUDIT_FIELDS,
                resolveEntity: true,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.COUNTERPARTY_TIN_REVEAL,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.COUNTERPARTY,
                fields: [],
                resolveEntity: true,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.COUNTERPARTY_TIN_EXPORT,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.COUNTERPARTY,
                fields: [],
                resolveEntity: true,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
    ...toPlatformTwinSources(COUNTERPARTY_DETAIL_PLATFORM_TWINS).map(
        ({ sourceType, platformTwins }): HistorySourceTypeConfig => ({
            sourceType,
            resourceTypeConfigs: [
                {
                    resourceType: ResourceType.COUNTERPARTY,
                    fields: COUNTERPARTY_AUDIT_FIELDS,
                    resolveEntity: true,
                },
            ],
            groupBy: HistoryGroupBy.NONE,
            platformTwins,
            enabled: true,
        }),
    ),
    {
        sourceType: APIProcessName.ADMIN_EDIT_COUNTERPARTY,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.COUNTERPARTY,
                fields: COUNTERPARTY_AUDIT_FIELDS,
                resolveEntity: true,
            },
        ],
        groupBy: HistoryGroupBy.NONE,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.COUNTERPARTY_FIELD_REVIEW_ADD,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.COUNTERPARTY_FIELD_REVIEW,
                fields: [HistoryField.REVIEWED_FIELD],
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
    {
        sourceType: APIProcessName.COUNTERPARTY_FIELD_REVIEW_REVOKE,
        resourceTypeConfigs: [
            {
                resourceType: ResourceType.COUNTERPARTY_FIELD_REVIEW,
                fields: [HistoryField.REVIEWED_FIELD],
            },
        ],
        groupBy: HistoryGroupBy.FIELD,
        platformTwins: null,
        enabled: true,
    },
];
